module.exports = __webpack_public_path__ + "static/36575D_0_0-75813ecf26e0f3eed87604aec5d1f90c.woff";